<template>
  <div class="relative max-w-xl px-6 py-6 mx-auto text-dark-type-4">
    <div>
      <div class="inline-flex items-center">
        <button :disabled="processing" @click="onClickBackButton">
          <img
            src="@/assets/img/back-button.svg"
            class="h-auto mr-4 md:w-auto md:h-auto"
            alt="Back button"
          />
        </button>
        <div class="font-bold text-center">Select payment method</div>
      </div>

      <div class="p-4 mt-8">
        <div
          class="flex items-start p-3 mb-5 bg-red-200 rounded-md"
          v-if="errorMessage"
        >
          <div class="text-sm font-medium text-red-500">{{ errorMessage }}</div>
        </div>
        <!-- <div
          v-if="processing"
          class="flex items-center justify-center flex-1 px-6 pt-12 pb-32"
        >
          <loading-indicator></loading-indicator>
        </div> -->
        <template>
          <template v-if="user">
            <!-- Pay with personal wallet option -->
            <button
              class="
                flex
                items-center
                justify-between
                w-full
                px-4
                py-5
                mb-2
                border border-opacity-50
                rounded-lg
                cursor-pointer
              "
              @click="selectPaymentType('main_balance')"
            >
              <div class="inline-flex items-center gap-2 leading-8">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.0308 3.33033C13.0345 2.88993 10.9655 2.88993 8.96917 3.33033L8.55155 3.42246C5.76343 4.03752 3.56534 6.17139 2.87698 8.93122C2.37434 10.9465 2.37434 13.0536 2.87698 15.0688C3.56534 17.8287 5.76343 19.9625 8.55155 20.5776L8.96917 20.6697C10.9655 21.1101 13.0345 21.1101 15.0308 20.6697L15.4484 20.5776C18.2366 19.9625 20.4347 17.8287 21.123 15.0688C21.6257 13.0536 21.6257 10.9465 21.123 8.93123C20.4347 6.17139 18.2366 4.03752 15.4484 3.42246L15.0308 3.33033ZM17.9433 9.80781C18.3203 9.74392 18.702 9.72118 19.0807 9.73874C19.4968 9.75804 19.8243 10.0826 19.8802 10.4936C20.0163 11.4933 20.0163 12.5068 19.8802 13.5064C19.8243 13.9175 19.4968 14.242 19.0807 14.2613C18.702 14.2789 18.3203 14.2561 17.9433 14.1923L17.8694 14.1797C16.8874 14.0133 16.1287 13.3508 15.8722 12.5159C15.7684 12.1783 15.7684 11.8217 15.8722 11.4841C16.1287 10.6493 16.8874 9.98677 17.8694 9.82035L17.9433 9.80781ZM7.34559 8.97735C7.34559 8.64347 7.6174 8.37281 7.95269 8.37281L12 8.37281C12.3353 8.37281 12.6071 8.64347 12.6071 8.97735C12.6071 9.31123 12.3353 9.58189 12 9.58189H7.95269C7.6174 9.58189 7.34559 9.31123 7.34559 8.97735Z"
                    fill="#444854"
                  />
                </svg>

                <div>
                  <p class="text-sm font-bold">Personal Wallet</p>
                  <p class="text-sm text-left">
                    &#8358;
                    {{
                      this.wallet.main_balance || this.wallet.amount | currency
                    }}
                  </p>
                </div>
              </div>
              <input
                type="checkbox"
                id="my-wallet"
                name="my-wallet"
                value="my-wallet"
                class="opacity-0"
              />
              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                    fill="#F5FFFA"
                    stroke="#20E682"
                  />
                </svg>
              </div>
            </button>

            <!-- Pay with company wallet option -->
            <button
              class="
                flex
                items-center
                justify-between
                w-full
                px-4
                py-5
                mb-2
                border border-opacity-50
                rounded-lg
                cursor-pointer
              "
              v-if="userHasCorporateAccount"
              @click="selectPaymentType('credit_balance')"
            >
              <div class="inline-flex items-center gap-2 leading-8">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.4735 6.5691C16.1393 4.94112 14.8994 3.60194 13.226 3.15932C12.4228 2.94689 11.5772 2.94689 10.774 3.15932C9.10056 3.60193 7.86065 4.94112 7.52652 6.56909C5.7394 7.03911 4.29056 8.32863 3.62976 10.0283C4.78247 10.4531 6.07377 10.7756 7.43687 10.9957V10.6861C7.43687 10.2931 7.75944 9.97461 8.15736 9.97461C8.55528 9.97461 8.87786 10.2931 8.87786 10.6861V11.1877C10.9249 11.405 13.0751 11.405 15.1221 11.1877V10.6861C15.1221 10.2931 15.4447 9.97461 15.8426 9.97461C16.2406 9.97461 16.5631 10.2931 16.5631 10.6861V10.9957C17.9262 10.7756 19.2175 10.4531 20.3702 10.0283C19.7094 8.32863 18.2606 7.03911 16.4735 6.5691ZM12.8531 4.53377C12.2942 4.38594 11.7058 4.38594 11.1469 4.53377C10.2243 4.77777 9.49537 5.42273 9.13156 6.24797C11.0286 5.91086 12.9714 5.91086 14.8684 6.24797C14.5046 5.42273 13.7757 4.77777 12.8531 4.53377Z"
                    fill="#444854"
                  />
                  <path
                    d="M15.1221 12.6182V14.0062C15.1221 14.3991 15.4447 14.7176 15.8426 14.7176C16.2406 14.7176 16.5631 14.3991 16.5631 14.0062V12.4361C18.0628 12.2072 19.4893 11.8618 20.7682 11.4C21.1214 12.9993 21.0702 14.6695 20.6203 16.2477C19.9834 18.4818 18.1227 20.1895 15.8115 20.6356C13.2943 21.1215 10.7057 21.1215 8.18854 20.6356C5.87734 20.1895 4.0166 18.4818 3.37975 16.2477C2.92985 14.6695 2.87864 12.9993 3.23182 11.4C4.51072 11.8618 5.93721 12.2072 7.43687 12.4361V14.0062C7.43687 14.3991 7.75944 14.7176 8.15736 14.7176C8.55528 14.7176 8.87786 14.3991 8.87786 14.0062V12.6182C10.9298 12.8254 13.0702 12.8254 15.1221 12.6182Z"
                    fill="#444854"
                  />
                </svg>

                <div>
                  <p class="text-sm font-bold">{{ companyName }}</p>
                  <p class="text-sm text-left">
                    &#8358; {{ this.wallet.credit_amount | currency }}
                  </p>
                </div>
              </div>
              <input
                type="checkbox"
                id="company-wallet"
                name="company-wallet"
                value="company-wallet"
                class="opacity-0"
              />
              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                    fill="#F5FFFA"
                    stroke="#20E682"
                  />
                </svg>
              </div>
            </button>
          </template>

          <!-- Pay with bank option -->
          <button
            class="
              flex
              items-center
              justify-between
              w-full
              px-4
              py-5
              mb-2
              border border-opacity-50
              rounded-lg
              cursor-pointer
            "
            @click="selectPaymentType('instant_payment')"
          >
            <div class="inline-flex items-center gap-2 leading-8">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5116 2.63407C12.1783 2.53164 11.822 2.53164 11.4887 2.63407L8.50297 3.55174C6.96862 4.02333 5.51144 4.71666 4.17766 5.60977C3.32982 6.17748 3.7317 7.49997 4.75205 7.49997H19.2482C20.2686 7.49997 20.6705 6.17748 19.8226 5.60977C18.4888 4.71666 17.0317 4.02333 15.4973 3.55174L12.5116 2.63407Z"
                  fill="#444854"
                />
                <path
                  d="M4.25012 21C4.25012 20.5858 4.58591 20.25 5.00012 20.25H19.0001C19.4143 20.25 19.7501 20.5858 19.7501 21C19.7501 21.4142 19.4143 21.75 19.0001 21.75H5.00012C4.58591 21.75 4.25012 21.4142 4.25012 21Z"
                  fill="#444854"
                />
                <path
                  d="M6.25012 17C6.25012 17.4142 6.58591 17.75 7.00012 17.75C7.41434 17.75 7.75012 17.4142 7.75012 17L7.75012 11C7.75012 10.5858 7.41434 10.25 7.00012 10.25C6.58591 10.25 6.25012 10.5858 6.25012 11L6.25012 17Z"
                  fill="#444854"
                />
                <path
                  d="M12.0001 17.75C11.5859 17.75 11.2501 17.4142 11.2501 17L11.2501 11C11.2501 10.5858 11.5859 10.25 12.0001 10.25C12.4143 10.25 12.7501 10.5858 12.7501 11V17C12.7501 17.4142 12.4143 17.75 12.0001 17.75Z"
                  fill="#444854"
                />
                <path
                  d="M16.2501 17C16.2501 17.4142 16.5859 17.75 17.0001 17.75C17.4143 17.75 17.7501 17.4142 17.7501 17V11C17.7501 10.5858 17.4143 10.25 17.0001 10.25C16.5859 10.25 16.2501 10.5858 16.2501 11V17Z"
                  fill="#444854"
                />
              </svg>
              <p class="text-sm font-bold">Pay with Bank</p>
            </div>
            <input
              type="checkbox"
              id="pay-with-bank"
              name="pay-with-bank"
              value="bank"
              class="opacity-0"
            />
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                  fill="#F5FFFA"
                  stroke="#20E682"
                />
              </svg>
            </div>
          </button>

          <!-- Pay with card option -->
          <button
            class="
              flex
              items-center
              justify-between
              w-full
              px-4
              py-5
              mb-2
              border border-opacity-50
              rounded-lg
              cursor-pointer
            "
            @click="selectPaymentType('instant_payment')"
          >
            <div class="inline-flex items-center gap-2 leading-8">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0308 3.33033C13.0345 2.88993 10.9655 2.88993 8.96917 3.33033L8.55155 3.42246C5.76343 4.03752 3.56534 6.17139 2.87698 8.93122C2.37434 10.9465 2.37434 13.0536 2.87698 15.0688C3.56534 17.8287 5.76343 19.9625 8.55155 20.5776L8.96917 20.6697C10.9655 21.1101 13.0345 21.1101 15.0308 20.6697L15.4484 20.5776C18.2366 19.9625 20.4347 17.8287 21.123 15.0688C21.6257 13.0536 21.6257 10.9465 21.123 8.93123C20.4347 6.17139 18.2366 4.03752 15.4484 3.42246L15.0308 3.33033ZM17.9433 9.80781C18.3203 9.74392 18.702 9.72118 19.0807 9.73874C19.4968 9.75804 19.8243 10.0826 19.8802 10.4936C20.0163 11.4933 20.0163 12.5068 19.8802 13.5064C19.8243 13.9175 19.4968 14.242 19.0807 14.2613C18.702 14.2789 18.3203 14.2561 17.9433 14.1923L17.8694 14.1797C16.8874 14.0133 16.1287 13.3508 15.8722 12.5159C15.7684 12.1783 15.7684 11.8217 15.8722 11.4841C16.1287 10.6493 16.8874 9.98677 17.8694 9.82035L17.9433 9.80781ZM7.34559 8.97735C7.34559 8.64347 7.61739 8.37281 7.95269 8.37281L12 8.37281C12.3353 8.37281 12.6071 8.64347 12.6071 8.97735C12.6071 9.31123 12.3353 9.58189 12 9.58189H7.95269C7.61739 9.58189 7.34559 9.31123 7.34559 8.97735Z"
                  fill="#444854"
                />
              </svg>

              <p class="text-sm font-bold">Pay with Card</p>
            </div>
            <input
              type="checkbox"
              id="pay-with-card"
              name="pay-with-card"
              value="card"
              class="opacity-0"
            />
            <div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z"
                  fill="#F5FFFA"
                  stroke="#20E682"
                />
              </svg>
            </div>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    paymentInformation: Object,
  },
  data() {
    return {
      processing: false,
      walletOptions: [
        { label: "Personal", id: "main_balance" },
        { label: "Corporate", id: "credit_balance" },
      ],
      paymentOptions: [
        { label: "Instant Payment", id: "instant_payment" },
        { label: "Wallet", id: "wallet" },
      ],
      selectedPaymentOption: "",
      errorMessage: null,
    };
  },
  created() {},
  computed: {
    ...mapGetters("app", ["wallet"]),
    ...mapGetters("auth", ["user"]),
    userHasCorporateAccount() {
      return this.user.corporate_id;
    },
    companyName() {
      if (!this.user.corporate_id) {
        return "";
      }
      return "Company Credit";
    },
  },
  methods: {
    isWalletPayment(option) {
      return ["credit_balance", "main_balance"].includes(option);
    },
    isInstantPayment(option) {
      return option === "instant_payment";
    },
    selectPaymentType(paymentType) {
      if (this.isWalletPayment(paymentType)) {
        this.paymentInformation.paymentOption = "wallet";
        this.paymentInformation.walletSource = paymentType;
        this.$store.dispatch("app/changeWalletSource", paymentType);
      }

      if (this.isInstantPayment(paymentType)) {
        this.paymentInformation.paymentOption = paymentType;
      }

      this.$emit("proceed-to-process-booking", this.paymentInformation);
    },
    onClickBackButton() {
      this.$emit("close");
    },
  },
};
</script>
